module.exports = __webpack_public_path__ + "static/media/admission smart final icon.5ce16b61.svg";